import React from "react";
import styled from "styled-components";
import {
    Button,
    PortalMetricCard,
    PortalMetricLabel,
    PortalMetricValue,
    portalColors
} from "src/components";

const HeaderMetricCard = styled(PortalMetricCard)`
    width: ${p => p.width || "257px"};
    max-width: 100%;
    min-height: 117px;
    padding-top: 0.875rem;
`;

const HeaderMetricTop = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

const HeaderMetricIcon = styled.img`
    width: 21px;
    height: 21px;
    object-fit: contain;

    [data-theme="dark"] & {
        filter: brightness(0) invert(1);
        opacity: 0.92;
    }
`;

const HeaderMetricActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    margin-top: 0.6rem;
`;

export default function HeaderCards(props) {
    const { title, icon, quantity, toggleFunction, width } = props;
    return (
        <HeaderMetricCard width={width ? `${width}` : "257px"}>
            <HeaderMetricTop>
                <HeaderMetricIcon src={icon} alt="" />
                <PortalMetricLabel>{title}</PortalMetricLabel>
            </HeaderMetricTop>
            <HeaderMetricActions>
                <PortalMetricValue size="1.875rem">{quantity || 0}</PortalMetricValue>
                {toggleFunction ?
                    <Button
                        onClick={() => toggleFunction()}
                        backgroundColor={portalColors.text}
                        border={`1px solid ${portalColors.text}`}
                        color="var(--calendar-bg, #FFFFFF)"
                        width="93px"
                        height="35px"
                        minHeight="35px"
                        style={{ borderRadius: "7px", boxShadow: "none" }}
                    > Manage
                    </Button>
                    : null}
            </HeaderMetricActions>
        </HeaderMetricCard>
    );
}
